import React, { useState, useEffect } from "react";

export default function RfidTable({ rfids, isLoading, error, onEdit }) {
  if (error) {
    return (
      <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-6 border border-red-200 text-sm">
        {error}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
        <div className="p-20 text-center">
          <div className="inline-block animate-spin w-6 h-6 border-2 border-neutral-900 border-t-transparent rounded-full mb-2"></div>
          <p className="text-sm text-neutral-500">Loading RFIDs...</p>
        </div>
      </div>
    );
  }

  if (rfids.length === 0) {
    return (
      <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
        <div className="p-20 text-center text-neutral-500">No RFIDs found.</div>
      </div>
    );
  }

  return (
    <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
      <table className="w-full border-collapse">
        <thead className="bg-neutral-100 border-b">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-semibold text-neutral-500 uppercase">
              User ID
            </th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-neutral-500 uppercase">
              RFID
            </th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-neutral-500 uppercase">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-neutral-500 uppercase">
              Expiry
            </th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-neutral-500 uppercase">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          {rfids.map((r) => (
            <tr key={r.id} className="border-b hover:bg-neutral-50">
              <td className="px-6 py-4 text-sm">{r.user_id || "-"}</td>
              <td className="px-6 py-4 text-sm">{r.rfid || "-"}</td>
              <td className="px-6 py-4 text-sm">{r.status}</td>
              <td className="px-6 py-4 text-sm">{r.expiry_date || "-"}</td>
              <td className="px-6 py-4 text-sm">
                {onEdit ? (
                  <button
                    onClick={() => onEdit(r)}
                    className="text-neutral-900 hover:text-neutral-600 font-medium"
                  >
                    Edit
                  </button>
                ) : (
                  <span className="text-neutral-300">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}